/* HorecaBayim — mobil hareket sistemi (v2.4, 2026-10-08). defer ile yüklenir.
   Stiller: assets/hb-motion.css > "MOBİL HAREKET SİSTEMİ". Token'lar orada.

   Yalnız ≤749 px'te çalışır: masaüstünde hiçbir şey yapmaz (masaüstünün
   kendi açılma katmanı head'deki satır içi betikte, aynen duruyor).

   Güvenlik ilkeleri:
   - Hiçbir öğe CSS ile baştan gizlenmez. Gizleme sınıfını (.hb-rv) bu
     dosya, yalnız İLK EKRANIN ALTINDAKİ öğelere koyar: görünmeyen bir
     öğeyi gizlemek göze görünmez, ilk ekran ve LCP hiç beklemez.
   - Bir şey ters giderse (hata, IntersectionObserver yok) bütün
     işaretler kaldırılır; içerik her durumda görünür kalır.
   - prefers-reduced-motion: açılma hiç kurulmaz, geçişler CSS'te kapalı. */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 749px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- 0. anasayfa kategori ızgarası (v2.5, TÜM genişlikler) */
  // Kartlar görünür alana girerken: opacity 0→1, translateY 12→0, 450 ms,
  // aynı karede gelenler 50 ms arayla, toplam gecikme en fazla 300 ms; bir
  // kez. İlk ekrandakiler hiç işaretlenmez. Gizleme sınıfı (.hb-kv) yalnız
  // ilk ekranın altındaki kartlara JS ile konur: JS yoksa hiçbir şey gizli
  // kalmaz. Stil: hb-motion.css > "kategori ızgarası".
  (function categoryGrid() {
    // v2.6: değer kartları ve sektör kartları da aynı sistemle gelir
    // v2.8: blog kartları (liste, anasayfa, ilgili yazılar, yazıdaki ürünler)
    var items = document.querySelectorAll('.hb-ks__grid > .hb-ks__item, .hb-dk__item, .hb-sk__item, .hb-bc-li');
    if (!items.length || REDUCE || !('IntersectionObserver' in window)) return;
    var STEP = 50, MAX = 300, DUR = 450;
    function clear(el) {
      el.classList.remove('hb-kv', 'is-in');
      el.style.removeProperty('--hb-kv-d');
    }
    function order(a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      return Math.abs(ra.top - rb.top) > 8 ? ra.top - rb.top : ra.left - rb.left;
    }
    try {
      var io = new IntersectionObserver(function (entries) {
        var batch = [];
        entries.forEach(function (e) {
          if (e.isIntersecting) { io.unobserve(e.target); batch.push(e.target); }
        });
        batch.sort(order).forEach(function (el, i) {
          el.style.setProperty('--hb-kv-d', Math.min(i * STEP, MAX) + 'ms');
          el.classList.add('is-in');
          setTimeout(function () { clear(el); }, DUR + MAX + 120);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
      var vh = window.innerHeight;
      Array.prototype.forEach.call(items, function (li) {
        if (li.getBoundingClientRect().top < vh - 4) return; // ilk ekran: beklemeden görünür
        li.classList.add('hb-kv');
        io.observe(li);
      });
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) Array.prototype.forEach.call(document.querySelectorAll('.hb-kv'), clear);
      });
    } catch (err) {
      Array.prototype.forEach.call(document.querySelectorAll('.hb-kv'), clear);
    }
  })();

  if (!MOBILE.matches) return;
  var doc = document.documentElement;
  doc.classList.add('hb-m');

  var STAGGER = 60; // ms, kartlar arası
  var STAGGER_MAX = 360; // ms, toplam gecikme sınırı

  var api = (window.hbMotion = window.hbMotion || {});

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* ------------------------------------------- 1. görünür alana geliş */
  // Satır (yatay şerit) içindeki kartlar şeritle birlikte, ızgaradaki
  // kartlar tek tek gözlenir. Aynı karede görünür alana giren kartlar
  // soldan sağa / yukarıdan aşağı 60 ms arayla gelir.
  var ROWS = '.hb-oc__row';
  var ITEMS = '.hb-coll-grid > .hb-coll-item, .product-grid__item, .hb-bl__grid > *';

  var io = null;

  function clearReveal(el) {
    el.classList.remove('hb-rv', 'is-in');
    el.style.removeProperty('--hb-rv-d');
  }

  function show(list) {
    // list: aynı karede görünür olan öğeler, ekrandaki sıraya göre
    list.forEach(function (el, i) {
      el.style.setProperty('--hb-rv-d', Math.min(i * STAGGER, STAGGER_MAX) + 'ms');
      el.classList.add('is-in');
      var done = function (e) {
        if (e && e.target !== el) return;
        el.removeEventListener('transitionend', done);
        clearReveal(el);
      };
      el.addEventListener('transitionend', done);
      // geçiş olayı gelmezse (sekme arka planda vb.) yine de temizle
      window.setTimeout(done, 520 + STAGGER_MAX + 200);
    });
  }

  function byScreenOrder(a, b) {
    var ra = a.getBoundingClientRect();
    var rb = b.getBoundingClientRect();
    return Math.abs(ra.top - rb.top) > 8 ? ra.top - rb.top : ra.left - rb.left;
  }

  function onIntersect(entries) {
    var batch = [];
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var t = entry.target;
      io.unobserve(t);
      if (t.matches(ROWS)) {
        var vw = window.innerWidth;
        var inView = [];
        each(t.children, function (li) {
          if (!li.classList.contains('hb-rv')) return;
          var r = li.getBoundingClientRect();
          if (r.left < vw && r.right > 0) inView.push(li);
          else clearReveal(li); // ekran dışındaki kart: animasyonsuz, hazır
        });
        show(inView);
      } else {
        batch.push(t);
      }
    });
    if (batch.length) show(batch.sort(byScreenOrder));
  }

  function belowFold(el) {
    var r = el.getBoundingClientRect();
    return r.top > window.innerHeight - 4;
  }

  function scan(root) {
    if (REDUCE || !io) return;
    root = root || document;
    // yatay şeritler
    each(root.querySelectorAll(ROWS), function (row) {
      if (row.dataset.hbRv) return;
      row.dataset.hbRv = '1';
      if (!belowFold(row)) return;
      each(row.children, function (li) {
        li.classList.add('hb-rv');
      });
      io.observe(row);
    });
    // ızgara kartları
    each(root.querySelectorAll(ITEMS), function (el) {
      if (el.dataset.hbRv) return;
      el.dataset.hbRv = '1';
      if (!belowFold(el)) return;
      el.classList.add('hb-rv');
      io.observe(el);
    });
  }

  function revealAll() {
    each(document.querySelectorAll('.hb-rv'), clearReveal);
  }

  try {
    if (!REDUCE && 'IntersectionObserver' in window) {
      // Kök viewport: mobilde sayfa window'da kayıyor (.page-wrapper
      // taşmıyor), bu yüzden gözlemci her kaydırmada güncellenir.
      io = new IntersectionObserver(onIntersect, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
      scan(document);
    }
  } catch (err) {
    revealAll();
  }

  // Sonradan eklenen kartlar ("Daha fazla yükle") bunu çağırır — masaüstü
  // katmanının aynı adlı kancasıyla uyumlu.
  window.hbReveal = {
    scan: function (node) {
      try {
        scan(node || document);
      } catch (err) {
        revealAll();
      }
    }
  };

  // Sayfa geri/ileri önbellekten dönerse yarım kalan bir şey olmasın.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) revealAll();
  });

  /* -------------------------------------------------- 2. header */
  // Aşağı kaydırınca header ve WhatsApp balonu çekilir; yukarı kaydırınca
  // geri gelir. Çekmece, arama paneli ya da alt panel açıkken gizlenmez.
  (function header() {
    var section = document.querySelector('#header-group > .header-section');
    if (!section) return;
    var lastY = window.scrollY;
    var ticking = false;
    var THRESHOLD = 8;

    function locked() {
      return (
        document.querySelector('#Details-menu-drawer-container[open]') ||
        document.querySelector('.hb-search-open') ||
        document.querySelector('.hb-sheet.is-open') ||
        (document.activeElement && document.activeElement.id === 'hb-header-search')
      );
    }

    // Yapışkan öğenin offsetTop'u yapıştığı anda kaydırmayla birlikte
    // değişir; eşik bu yüzden yapışkan OLMAYAN duyuru çubuğundan ölçülür.
    function baseTop() {
      var prev = section.previousElementSibling;
      return prev ? prev.getBoundingClientRect().bottom + window.scrollY : 0;
    }

    function update() {
      ticking = false;
      var y = Math.max(0, window.scrollY);
      var dy = y - lastY;
      var base = baseTop();
      var top = base + section.offsetHeight; // duyuru + header
      doc.classList.toggle('hb-hdr-stuck', y > base + 2);
      if (locked() || y <= top) {
        doc.classList.remove('hb-hdr-hide');
      } else if (dy > THRESHOLD) {
        doc.classList.add('hb-hdr-hide');
      } else if (dy < -THRESHOLD) {
        doc.classList.remove('hb-hdr-hide');
      }
      if (Math.abs(dy) > THRESHOLD) lastY = y;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    // klavye odağı header'a girerse görünür olsun
    section.addEventListener('focusin', function () {
      doc.classList.remove('hb-hdr-hide');
    });

    api.showHeader = function () {
      doc.classList.remove('hb-hdr-hide');
    };
    update();
  })();

  /* -------------------------------------------- 3. menü çekmecesi */
  // Çekmecedeki satırlar sırayla (40 ms) gelir. Sıra numarası burada
  // verilir; görünürlük tamamen CSS'te (.menu-open altında).
  (function drawer() {
    var container = document.getElementById('Details-menu-drawer-container');
    if (!container || REDUCE) return;
    // Horizon çekmece içeriğini yüklemeden sonra yeniden kurabiliyor; bu
    // yüzden satırlar menü AÇILIRKEN işaretlenir (yakalama aşamasında,
    // Horizon'un kendi tıklama işleyicisinden önce). İşaretten sonra stil
    // bir kez okunur ki gizli başlangıç durumu kaydedilsin ve .menu-open
    // gelince geçiş gerçekten oynasın.
    function mark() {
      var drawerEl = container.querySelector('.menu-drawer');
      if (!drawerEl) return;
      var rows = drawerEl.querySelectorAll(
        '.hb-dcat__head, .hb-dcat > .hb-dcat__item, .menu-drawer__menu > li:not(.hb-dcat), .menu-drawer__utility-links'
      );
      var i = 0;
      // İşaret geçişsiz konur: kapalı durumun kendi 180 ms'lik geçişi
      // "görünür→gizli" diye oynarsa menü açılırken satırlar hiç gizlenmez.
      each(rows, function (row) {
        if (!row.hasAttribute('data-hb-dr')) {
          row.style.transition = 'none';
          row.setAttribute('data-hb-dr', '');
        }
        row.style.setProperty('--hb-i', String(Math.min(i++, 12)));
      });
      if (rows.length) void getComputedStyle(rows[rows.length - 1]).opacity;
      each(rows, function (row) {
        row.style.removeProperty('transition');
      });
      if (rows.length) void getComputedStyle(rows[rows.length - 1]).opacity;
    }
    var summary = container.querySelector(':scope > summary');
    if (summary) {
      summary.addEventListener('click', function () {
        if (!container.open) mark();
      }, true);
    }
  })();

  /* ---------------------------------------------------- 4. alt panel */
  // api.sheet(el): el = .hb-sheet (içinde .hb-sheet__scrim, .hb-sheet__panel,
  // isteğe bağlı [data-hb-sheet-grip]). Aşağı sürükleyince kapanır.
  api.sheet = function (sheet, opts) {
    opts = opts || {};
    var panel = sheet.querySelector('.hb-sheet__panel');
    var scrim = sheet.querySelector('.hb-sheet__scrim');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      sheet.hidden = false;
      sheet.setAttribute('aria-hidden', 'false');
      // bir kare sonra sınıf: başlangıç konumundan kayarak gelsin
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          sheet.classList.add('is-open');
          var f = panel.querySelector('[data-hb-sheet-focus]') || panel.querySelector('button, a, input, select');
          if (f) f.focus({ preventScroll: true });
        });
      });
      document.addEventListener('keydown', onKey);
      document.body.style.overflow = 'hidden';
      if (opts.onOpen) opts.onOpen();
    }

    function close() {
      if (!sheet.classList.contains('is-open')) return;
      sheet.classList.remove('is-open');
      sheet.style.removeProperty('--hb-sheet-dy');
      sheet.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      if (opts.onClose) opts.onClose();
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    scrim.addEventListener('click', close);
    each(sheet.querySelectorAll('[data-hb-sheet-close]'), function (b) {
      b.addEventListener('click', close);
    });

    // aşağı sürükle → kapat. Tutamak + başlıktan, ya da içerik en üstteyken
    // içerikten başlayan sürükleme sayılır.
    var startY = 0;
    var startT = 0;
    var dy = 0;
    var dragging = false;
    var body = panel.querySelector('.hb-sheet__body');

    function down(e) {
      if (!sheet.classList.contains('is-open')) return;
      var fromGrip = e.target.closest('[data-hb-sheet-grip]');
      if (!fromGrip && !(body && body.contains(e.target) && body.scrollTop <= 0)) return;
      startY = e.touches ? e.touches[0].clientY : e.clientY;
      startT = Date.now();
      dy = 0;
      dragging = true;
    }

    function move(e) {
      if (!dragging) return;
      var y = e.touches ? e.touches[0].clientY : e.clientY;
      dy = Math.max(0, y - startY);
      if (dy > 4) {
        sheet.classList.add('is-dragging');
        sheet.style.setProperty('--hb-sheet-dy', dy + 'px');
        scrim.style.opacity = String(Math.max(0, 1 - dy / (panel.offsetHeight || 1)));
        if (e.cancelable) e.preventDefault();
      }
    }

    function up() {
      if (!dragging) return;
      dragging = false;
      sheet.classList.remove('is-dragging');
      scrim.style.removeProperty('opacity');
      var v = dy / Math.max(1, Date.now() - startT); // px/ms
      if (dy > Math.min(120, panel.offsetHeight * 0.3) || (dy > 24 && v > 0.6)) close();
      else sheet.style.removeProperty('--hb-sheet-dy');
    }

    panel.addEventListener('touchstart', down, { passive: true });
    panel.addEventListener('touchmove', move, { passive: false });
    panel.addEventListener('touchend', up);
    panel.addEventListener('touchcancel', up);
    panel.addEventListener('mousedown', down);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);

    return { open: open, close: close };
  };

  /* ------------------------------------------------------ 5. akordeon */
  // <details> gövdesi grid kabına alınır; açılırken satır 0fr→1fr akar,
  // kapanırken animasyon bitince details kapanır. JS yoksa native çalışır.
  // Bağlama kaydı WeakSet'te (öznitelikte DEĞİL): Horizon bazı bölümleri
  // yerinde yeniden eşleyip (morph) özniteliklerimizi siliyor, düğüm ve
  // dinleyici ise kalıyor. Öznitelikle tutulan kayıt silinince ikinci
  // dinleyici bağlanıyor, tek dokunuş açıp hemen kapatıyordu (v2.4 çekmece
  // "+" hatası). Sarmalayıcı silinmişse yeniden kurulur, dinleyici eklenmez.
  var bound = typeof WeakSet === 'function' ? new WeakSet() : null;
  function wrap(details, summary) {
    // ürün akordeonunda "+ / –" karakteri yerine dönen ok
    if (details.classList.contains('hb-acc') && !summary.querySelector('.hb-acc-chev')) {
      summary.insertAdjacentHTML(
        'beforeend',
        '<svg class="hb-acc-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>'
      );
    }
    if (details.querySelector(':scope > .hb-acc-grid')) return details.querySelector(':scope > .hb-acc-grid');
    var grid = document.createElement('div');
    grid.className = 'hb-acc-grid';
    var inner = document.createElement('div');
    inner.className = 'hb-acc-inner';
    grid.appendChild(inner);
    while (summary.nextSibling) inner.appendChild(summary.nextSibling);
    details.appendChild(grid);
    return grid;
  }

  api.accordion = function (details) {
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;
    if (bound ? bound.has(details) : details.dataset.hbAcc) {
      wrap(details, summary);
      return;
    }
    if (bound) bound.add(details);
    details.dataset.hbAcc = '1';
    wrap(details, summary);
    if (details.open) details.classList.add('is-open');

    var timer = 0;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      window.clearTimeout(timer);
      var grid = wrap(details, summary);
      if (!details.classList.contains('is-open')) {
        details.open = true;
        void grid.offsetHeight; // 0fr başlangıcını kaydet
        details.classList.add('is-open');
      } else {
        details.classList.remove('is-open');
        var finish = function () {
          if (!details.classList.contains('is-open')) details.open = false;
        };
        if (REDUCE) finish();
        else timer = window.setTimeout(finish, 340);
      }
    });
  };

  // Ürün detay akordeonları. (Çekmece kategorileri v2.5'ten beri kendi
  // düğmeli yapısında: snippets/hb-catnav-drawer.liquid.)
  each(document.querySelectorAll('details.hb-acc'), api.accordion);

  /* --------------------------------------- 6. sepete ekleme geri bildirimi */
  api.confirm = function (button) {
    if (!button || REDUCE) return;
    if (!button.querySelector('.hb-tick')) {
      var t = document.createElement('span');
      t.className = 'hb-tick';
      t.setAttribute('aria-hidden', 'true');
      t.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      button.appendChild(t);
    }
    button.classList.remove('is-added');
    void button.offsetWidth;
    button.classList.add('is-added');
    window.setTimeout(function () {
      button.classList.remove('is-added');
    }, 1400);
  };

  api.pop = function () {
    var bubble = document.querySelector('cart-icon .cart-bubble');
    if (!bubble || REDUCE) return;
    bubble.classList.remove('hb-pop');
    void bubble.offsetWidth;
    bubble.classList.add('hb-pop');
  };
})();
